import Utils from "../../../../shared/utils";

export const HEADER_ANIMATION = Utils.buildMortPersonalAreaImgLink(
  "animations/header-animation.svg"
);
export const NO_DATA = Utils.buildMortPersonalAreaImgLink(
  "animations/no-data.svg"
);
